import Enum from "../../../../../enums/Enum";

const EnumVisaStatus = new Enum({
    CITIZEN: "Citizen",
    RESIDENT: "Resident",
    VISITING: "Visiting"
});

export default EnumVisaStatus;